import { SuburbGraph } from '../rules/suburb-map-checks';
import { AU_STATES } from './map-types';

/**
 * The suburb shapes and their adjacency graph (#256), fetched from src/assets/suburbs/ (built by
 * conductor-suburb-mapper) and kept for as long as the map is open. A failed fetch isn't kept, so the next call tries
 * again.
 */
export class SuburbShapes {
  private states = new Map<string, Promise<any[]>>();
  private graphPromise: Promise<SuburbGraph> | null = null;

  /** One state's suburb polygons (GeoJSON features). */
  featuresFor(code: string): Promise<any[]> {
    let hit = this.states.get(code);
    if (!hit) {
      hit = fetch(`assets/suburbs/${code}.json`)
        .then((r) => {
          if (!r.ok) throw new Error(`suburb shapes for ${code.toUpperCase()}: HTTP ${r.status}`);
          return r.json();
        })
        .then((gj) => gj.features);
      hit.catch(() => this.states.delete(code));
      this.states.set(code, hit);
    }
    return hit;
  }

  /** Every state's features (the overview, exports). */
  async allFeatures(): Promise<any[]> {
    return (await Promise.all(AU_STATES.map((s) => this.featuresFor(s.code)))).flat();
  }

  /** Which suburbs border which, and an interior point for each (checks, grow, flying to a suburb by code). */
  graph(): Promise<SuburbGraph> {
    if (!this.graphPromise) {
      this.graphPromise = fetch('assets/suburbs/graph.json').then((r) => {
        if (!r.ok) throw new Error(`suburb graph: HTTP ${r.status}`);
        return r.json();
      });
      this.graphPromise.catch(() => (this.graphPromise = null));
    }
    return this.graphPromise;
  }
}
